import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchArticle } from "../../redux/layoutSlice";

function removeAllScriptTags(input) {
    const scriptTagRegex = /<script\b[^>]*>[\s\S]*?<\/script>/gi;
    return input.replace(scriptTagRegex, "");
}

function extractAllScriptContents(input) {
    const scriptTagRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
    const scripts = [];
    let match;

    while ((match = scriptTagRegex.exec(input)) !== null) {
        const attrs = match[1]; // everything inside <script ...>
        const innerHtml = match[2]; // content between the tags

        // Extract src and type attributes
        const srcMatch = attrs.match(/\bsrc\s*=\s*["']?([^"'\s>]+)["']?/i);
        const typeMatch = attrs.match(/\btype\s*=\s*["']?([^"'\s>]+)["']?/i);

        const src = srcMatch ? srcMatch[1] : null;
        const type = typeMatch ? typeMatch[1] : null;

        scripts.push({ src, type, innerHtml });
    }

    return scripts;
}

function EmbedScript({ contents, body: bodyFromProps, id: idFromProps }) {
    const { articleId: articleIdFromParams } = useParams();
    const id = contents?.[0]?.id || articleIdFromParams;
    const location = useLocation();

    const dispatch = useDispatch();
    const content = useSelector((state) => state.layout.content);

    const [isLoading, setIsLoading] = useState(!!id);
    const [didDispatch, setDidDispatch] = useState(false);

    useEffect(() => {
        if (isLoading && !didDispatch) {
            dispatch(fetchArticle({ id }));
            setDidDispatch(true);
        }
        if (isLoading && content[id]) {
            setIsLoading(false);
        }
    }, [isLoading, content, didDispatch, id, dispatch]);

    const { body: _body } = content[id] || { body: bodyFromProps };

    const scriptsTags = extractAllScriptContents(_body);
    const htmlWithoutScripts = removeAllScriptTags(_body);

    useEffect(() => {
        if (!scriptsTags.length) return;

        const injectedScripts = [];

        scriptsTags.forEach((script, i) => {
            const existing = document.getElementById(`script-el-${idFromProps}-${i}`);
            if (!existing) {
                const scriptEl = document.createElement("script");
                scriptEl.id = `script-el-${idFromProps}-${i}`;

                if (script.innerHtml) {
                    scriptEl.innerHTML = `(function() { ${script.innerHtml} })();`;
                }
                if (script.src) scriptEl.src = script.src;
                if (script.type) scriptEl.type = script.type;

                document.body.appendChild(scriptEl);
                injectedScripts.push(scriptEl);
            }
        });

        return () => {
            // Optional cleanup to prevent duplicates
            injectedScripts.forEach((el) => {
                if (document.body.contains(el)) {
                    document.body.removeChild(el);
                }
            });
        };
        // we added JSON.stringify(scriptsTags) to ensure effect re-runs when the script list changes.
    }, [idFromProps, JSON.stringify(scriptsTags)]);

    useEffect(() => {
        const scrollEl = document.getElementById("scrollMessage");

        if (!scrollEl) return;

        const handleScroll = () => {
            if (window.scrollY <= 10) {
                scrollEl.classList.remove("hidden");
            } else {
                scrollEl.classList.add("hidden");
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [location.key]);

    return <div dangerouslySetInnerHTML={{ __html: htmlWithoutScripts }} />;
}

export default EmbedScript;
